{
  "schemaVersion": 1,
  "id": "birch-ply-18",
  "version": "1.0",
  "material": "Birch plywood",
  "nominalDescription": "Birch plywood 18 mm, B/BB, clear matt lacquer",
  "backDescription": "Birch plywood 6 mm, B/BB, clear matt lacquer",
  "nominalThicknessTicks": 180,
  "measuredThicknessTicks": 180,
  "nominalBackThicknessTicks": 60,
  "backThicknessTicks": 60,
  "measuredBy": null,
  "measuredAt": null,
  "plies": { "carcass": 13, "back": 5 },
  "sheet": { "lengthTicks": 24400, "widthTicks": 12200 },
  "grainAxis": "length",
  "allowRotation": false,
  "faceGrade": "B/BB",
  "finishSpec": "Clear matt lacquer",
  "notes": "Measured thickness is entered here by the maker, never in the customer UI. 18.0 is the nominal value until the maker measures the actual sheet."
}
